import React from 'react';

import {Content, ContentSection} from 'components';
import {Heading} from 'components/ultra';
import Sidebar from 'containers/sidebar';
import {service as auth} from 'utilities/auth';

import {StravaLink} from './styles';
import StravaButton from './images/strava-button.svg';

export function SignUp() {
  return (
    <>
      <Sidebar />
      <Content>
        <ContentSection footerWidth>
          <Heading element="h1" gradient={true}>
            Sign up
          </Heading>
          <Heading>Use Strava to sign up for Spurtli</Heading>
        </ContentSection>
        <ContentSection footerWidth>
          <Heading>One click, many mementos</Heading>
          <p>
            When you sign up with us, we fetch your data from Strava, our
            software performs some magic and you will be able to create as many
            digital mementos as you like &ndash; without any cost.
          </p>
          <p>
            In order to make this magic happen, we need you to sign in with your
            Strava account and allow us to do the following things:
          </p>
          <ul>
            <li>read your profile data</li>
            <li>read you activity data</li>
          </ul>

          <StravaLink href={auth.currentAuthorizationProvider.authorizationUrl}>
            <img src={StravaButton} />
          </StravaLink>
          <Heading element="h3">Had enough of Spurtli?</Heading>
          <p>
            If you do not want to continue using Spurtli, you can at any time
            revoke access for Spurtli in your Strava user settings. As a result,
            all your data will be deleted.
          </p>
        </ContentSection>
      </Content>
    </>
  );
}
